import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ColumnFiltersState} from "@tanstack/react-table";
import {Dayjs} from "dayjs";

interface DogState {
    currentDogAudit : DogAudit[] | []
    elements: DogElement[],
    filter: { [key: string]: any };
    error: null | string;
    currentPage: number,
    rowsPerPage: number,
    totalRows: number,
    sort: string[],
    loading: boolean
}

export interface DogBox {
    boxId: string,
    listDog: string[]
}

export interface Box {
    _id: string,
    name: string,
    shedName: string
}

export interface Treatment {
    _id: string,
    notes: string,
    executionDate: string | Dayjs
    multimedias: {
        name: string,
        base64EncodedContent: string,
        type: string,
    }[];

}

export interface DogReport {
     dog: number
     dogAdopted: number
     dogReturned: number
     dogDead: number
}

export interface DogElement {
    _id: string,
    name: string,
    microchipCode: string,
    municipalityId: string,
    sex: string,
    photoProfil: string,
    isSterilizied: boolean,
    sterilizationDate: string | null,
    catchingDate: string | null,
    dogStatusType: string,
    catchingHealthStatus: string,
    coatColor: string,
    dogHairLength: string,
    multimedias: {
        name: string,
        base64EncodedContent: string,
        type: string
    }[],
    box: Box | null;
    treatments: Treatment[]
    race: string
    bornDate: string | null,
    returnedDate: string | null,
    diedDate: string | null,
    adoptionDate: string | null,
    sizeDog: string | null,
    roles?: string[];

}

export interface DogAudit {

    action: string;
    oldValue: Box;
    newValue: Box ;
    timestamp: string;
    username: string;

}

interface PageableDto {
    page: number;
    size: number;
    sort: string[];
}

export interface GetAllElementPayloadDog {
    pageableDto: PageableDto;
    filters: ColumnFiltersState | null
}

const initialState: DogState = {
    currentDogAudit: [],
    elements: [],
    error: null,
    filter: {},
    currentPage: 0,
    rowsPerPage: 10,
    totalRows: 0,
    sort: ['dateCreated', 'asc'],
    loading: false
}

export const Dog = createSlice({
    name: "Dog",
    initialState,
    reducers: {

        getAllElement: (state, action: PayloadAction<GetAllElementPayloadDog>) => {
            state.loading = true;
        },

        getAllElementSuccess: (state, action: PayloadAction<{ data: DogElement[], currentPage: number, totalRows: number }>) => {
            state.elements = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },
        getAllElementError: (state) => {
            state.loading = false;
        },

        setPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        setRowsPerPage: (state, action: PayloadAction<number>) => {
            state.rowsPerPage = action.payload;
        },
        setSort: (state, action: PayloadAction<string[]>) => {
            state.sort = action.payload;
        },
        getAllElementDogNotPageable: (state) => {
        },
        getAllElementSuccessDogNotPageable: (state, action: PayloadAction<DogElement[]>) => {
            state.elements = action.payload
        },
        getAllElementErrorDogNotPageable: (state) => {
            state.loading = false;
        },


        getAllElementDogMuniNotPageable: (state, action: PayloadAction<{filters: string, callback: () => void}>) => {
            state.loading = true;
            state.error = null;
        },

        getAllElementSuccessDogMuniNotPageable: (state, action: PayloadAction<{ data: DogElement[]}>) => {
            state.elements = action.payload.data;
            state.loading = false;
            state.error = null;
        },

        getAllElementErrorDogMuniNotPageable: (state) => {
            state.loading = false;
            state.error = 'Failed to fetch dogs data';
            state.elements = [];
        },


        getAllDogWithoutBox: state => {
        },
        getAllSuccessDogWithoutBox: (state, action: PayloadAction<DogElement[]>) => {
            state.elements = action.payload
        },
        getAllElementErrorDogWithoutBox: (state) => {
            state.loading = false;
        },

        getAllElementDead: (state, action: PayloadAction<GetAllElementPayloadDog>) => {
            state.loading = true
        },

        getAllElementDeadSuccess: (state, action: PayloadAction<{ data: DogElement[], currentPage: number, totalRows: number }>) => {
            state.elements = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },
        getAllElementDeadError: (state) => {
            state.loading = false;

        },

        getAllElementAdopted: (state, action: PayloadAction<GetAllElementPayloadDog>) => {
            state.loading = true
        },

        getAllElementAdoptedSuccess: (state, action: PayloadAction<{ data: DogElement[], currentPage: number, totalRows: number }>) => {
            state.elements = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },
        getAllElementAdoptedError: (state) => {
            state.loading = false;
        },

        getAllElementReturned: (state, action: PayloadAction<GetAllElementPayloadDog>) => {
            state.loading = true
        },

        getAllElementReturnedSuccess: (state, action: PayloadAction<{ data: DogElement[], currentPage: number, totalRows: number }>) => {
            state.elements = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },
        getAllElementReturnedError: (state) => {
            state.loading = false;
        },
        
        saveElement: (state, action: PayloadAction<{ data: DogElement, callback: () => void }>) => {
            state.loading = true;
        },


        saveElementSuccess: (state, actions: PayloadAction<DogElement>) => {
            state.elements.push(actions.payload)
            state.loading = false; // Aggiungi questo
            state.error = null;
        },
        saveElementError: (state) => {
            state.loading = false;
        },

        saveElementUser: (state, action: PayloadAction<DogElement>) => {
        },
        saveElementUserSuccess: (state, action: PayloadAction<DogElement>) => {
            const payload = {
                ...action.payload,

            }

            state.elements.push(payload);
            state.loading = false;

        },
        saveElementUserError: (state, action: PayloadAction<DogElement>) => {
            state.loading = false;
        },

        updateElement: (state, action: PayloadAction<{ data: DogElement, callback: () => void }>) => {
            state.loading = true;
        },
        updateElementSuccess: (state, actions: PayloadAction<DogElement>) => {
            let index = state.elements.findIndex(element => element._id === actions.payload._id)
            state.elements[index] = actions.payload
            state.loading = false; // Aggiungi questo
            state.error = null;
        },
        updateElementError: (state) => {
            state.loading = false;
        },

        updateElementBoxDogs: (state, actions: PayloadAction<{ idBox: string | null, dogIds: string[], callback: () => void }>) => {

        },

        updateElementBoxDogsSuccess: (state, actions: PayloadAction<{ idBox: string | null, dogIds: string[] }>) => {
            const { idBox, dogIds } = actions.payload;

            if (idBox === null) {
                // Handle the case where idBox is null
                console.error("Box ID cannot be null.");
                return;
            }

            if (state.elements && Array.isArray(state.elements)) {
                // Update the dogs and move them to the correct box
                state.elements = state.elements.map((dog) => {
                    if (dogIds.includes(dog._id)) {
                        return {
                            ...dog,
                            box: {
                                ...dog.box,
                                _id: idBox,  // Now idBox is guaranteed to be a string
                                name: dog?.box?.name || '', // Ensure name is a string
                                shedName: dog?.box?.shedName || '', // Ensure shedName is a string
                            },
                        };
                    }
                    return dog; // Keep the other dogs unchanged
                });
            }

            state.loading = false; // Operation completed
        },

        updateElementBoxDogssError: (state) => {
            state.loading = false;
        },

        deleteElement: (state, action: PayloadAction<{ id: string, callback: () => void }>) => {
        },
        deleteElementSuccess: (state, action: PayloadAction<string>) => {
            state.elements = state.elements.filter(el => el._id !== action.payload);
            state.loading = false; // Aggiungi questo
            state.error = null
        },

        deleteElementError: (state) => {
            state.loading = false;
        },

        getListDog: (state, action: PayloadAction<{filters: string[], callback: () => void}>) => {
            state.loading = true;
            state.error = null;
        },

        getListDogSuccessDog: (state, action: PayloadAction<{ data: DogElement[]}>) => {
            state.elements = action.payload.data;
            state.loading = false;
            state.error = null;
        },

        getListDogErrorDog: (state) => {
            state.loading = false;
            state.error = 'Failed to fetch dogs data';
            state.elements = [];
        },

        dogAction: (state, action: PayloadAction<string>) => {
            state.loading = true;
            state.error = null;
        },
        dogActionSuccess: (state, action:PayloadAction<DogAudit[]>) => {
            state.loading = false;
            state.error = null;
            state.currentDogAudit = action.payload

        },
        dogActionError: (state) => {
            state.loading = false;
        },
        
        getSingleDog: (state, action: PayloadAction<string>) => {
            state.loading = true;
            state.error = null;
        },
        getSingleDogSuccess: (state, action: PayloadAction<DogAudit>) => {
        },
        getSingleDogError: (state) => {
            state.loading = false;

        },

        getReport: (state) => {
            state.loading = true;
            state.error = null;
        },

        getReportSuccess: (state, action: PayloadAction<DogReport>) => {

            state.loading = false;
        },
        getReportError: (state) => {
            state.loading = false;
        },
    }

})

/*const filterData = (data: DogElement[], filter: { [key: string]: any }) => {
    return data.filter(element => {
        for (const key in filter) {
            if (filter.hasOwnProperty(key)) {

                const elementValue = element[key as keyof DogElement];
                const filterValue = filter[key];


                if (filterValue !== undefined && filterValue !== null && elementValue !== filterValue) {
                    return false;
                }
            }
        }
        return true;
    });
};*/

export const {
    getAllElement,
    getAllElementSuccess,
    getAllElementError,
    getAllElementDogNotPageable,
    getAllElementSuccessDogNotPageable,
    getAllElementErrorDogNotPageable,
    getAllSuccessDogWithoutBox,
    getAllElementErrorDogWithoutBox,
    getAllDogWithoutBox,
    setSort,
    setPage,
    saveElement,
    saveElementSuccess,
    saveElementError,
    updateElement,
    updateElementSuccess,
    updateElementError,
    deleteElement,
    deleteElementSuccess,
    deleteElementError,
    getAllElementDead,
    getAllElementDeadError,
    getAllElementDeadSuccess,
    getAllElementAdoptedError,
    getAllElementAdoptedSuccess,
    getAllElementAdopted,
    updateElementBoxDogsSuccess,
    updateElementBoxDogs,
    updateElementBoxDogssError,
    getAllElementReturned,
    getAllElementReturnedError,
    getAllElementReturnedSuccess,
    saveElementUser,
    saveElementUserError,
    saveElementUserSuccess,
    setRowsPerPage,
    getAllElementErrorDogMuniNotPageable,
    getAllElementSuccessDogMuniNotPageable,
    getAllElementDogMuniNotPageable,
    getListDogErrorDog,
    getListDogSuccessDog,
    getListDog,
    dogActionError,
    dogActionSuccess,
    dogAction,
    getSingleDogSuccess,
    getSingleDogError,
    getSingleDog,
    getReportError,
    getReport,
    getReportSuccess,
} = Dog.actions

export default Dog.reducer